import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import CustomLayer from "../IconsSvg/CustomLayer";
import { LazzyLoading } from "./contentTypeData";
import { useTranslation } from 'react-i18next';
import { FullscreenWrapper } from "../../lessons/details/fullscreen";

const StickbotTop = ({ url, title, type }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const [isIframeReady, setIsIframeReady] = useState(false);
  return (
    <FullscreenWrapper
      containerProps={{
        normalHeight: "100%",
        fullscreenHeight: "100vh"
      }}
      buttonProps={{
        position: "top-right",
        visible: true
      }}
    >
      <Box sx={{
        borderRadius: '20px',
        border: { sm: `1px solid ${theme.palette.common.disabled}`, xs: "none" },
        height: "calc(100% - 12px)"
      }}>
        <Box position="relative">
          <CustomLayer
            width="100%"
            startColor={theme.palette.primary.main}
            stopColor={theme.palette.primary.light}
          />

          <Box sx={{ position: "absolute", top: 0, margin: '1rem', right: 0, left: 0 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                bgcolor: "rgba(255,255,255,.1)",
                p: "2px 4px",
                borderRadius: 1,
                width: '100%'
              }}
            >
              <Box>
                <img
                  src="/assets/img/stickbot.png"
                  alt="Icon"
                  style={{ width: 35, height: 35, borderRadius: "50%" }}
                />
              </Box>
              <Typography variant="h6" sx={{ color: theme.palette.common.white, fontSize: "14px" }}>
                {
                  isMobile ?
                    title ? title?.substring(0, 30) + "..." : ""
                    :
                    <>
                      {title || ""} <span style={{ fontWeight: 400, fontSize: "12px" }}>{t("clickThrough")}</span>
                    </>
                }
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box height="calc(100% - 70px)">
          {!isIframeReady && <LazzyLoading />}
          <iframe
            onLoad={() => setIsIframeReady(true)}
            style={{
              paddingTop: '8px',
              width: "100%",
              height: "100%",
              opacity: 1,
            }}
            src={url}
            frameBorder="0"
          ></iframe>
        </Box>
      </Box >
    </FullscreenWrapper>
  );
};

export default StickbotTop;
